<template>
  <div class="b-root">
    <b-hero></b-hero>
    <b-services></b-services>
    <b-about></b-about>
    <b-contact></b-contact>
    <b-jobs></b-jobs>
    <b-foot></b-foot>
  </div>
</template>

<script>
import BHero from '@/views/BHero.vue';
import BServices from '@/views/BServices.vue';
import BAbout from '@/views/BAbout.vue';
import BContact from '@/views/BContact.vue';
import BJobs from '@/views/BJobs.vue';
import BFoot from '@/views/BFoot.vue';

export default {
  name: 'BRoot',
  components: {
    BServices,
    BAbout,
    BContact,
    BJobs,
    BFoot,
    BHero,
  },
}
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/initial-variables";
  @import "~bulma/sass/utilities/functions";
  @import "../styles/variables";
  @import "~bulma";
  @import "~bulma-pricingtable";
  @import "../styles/globals";
  @import "../styles/mobile";
  @import "../styles/helpers";
</style>
